export default "__VITE_ASSET__Bh74H$K7__"